import React from 'react';
import { motion } from 'framer-motion';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { capitalMetrics, metrics } from '../data/profile';
export function ImpactMetrics() {
  return <PageShell path="/impact" data-id="element-339" data-mp="2ayi7v5zwk3pv">
      <section className="bg-navy-950 py-20 lg:py-24" aria-labelledby="headline-metrics-heading" data-id="element-340" data-mp="2g07n6xu5r3jr">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-341" data-mp="1icfofzfgbua2">
          <div id="headline-metrics-heading" data-id="element-342" data-mp="1i9ult87bxab9">
            <SectionHeading eyebrow="Headline Outcomes" title="Four numbers that define the record" tone="dark" data-id="element-343" data-mp="1na8v0tko2qav" />
          </div>

          <dl className="mt-12 grid grid-cols-1 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-y-0" data-id="element-344" data-mp="1x1btroq4it6z">
            {metrics.map((metric, index) => <motion.div key={metric.value + metric.label} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.28,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col lg:px-8 ${index === 0 ? 'lg:pl-0' : 'lg:border-l lg:border-white/10'}`} data-id="element-345" data-mp="zl61oogo790j" data-mpi={index}>
                <dd className="font-display text-4xl font-extrabold tracking-tightest text-gold-400 xl:text-5xl" data-id="element-346" data-mp="3mmjvdlzzn61z">
                  {metric.value}
                </dd>
                <dt className="mt-4 font-display text-base font-semibold leading-snug text-white" data-id="element-347" data-mp="3com7x0pyddaf">
                  {metric.label}
                </dt>
                <dd className="mt-3 font-sans text-sm leading-relaxed text-platinum-300" data-id="element-348" data-mp="37rvjnq3zvbdx">
                  {metric.detail}
                </dd>
              </motion.div>)}
          </dl>
        </div>
      </section>

      <section className="bg-white py-20 lg:py-24" aria-labelledby="capital-metrics-heading" data-id="element-349" data-mp="11x3yc9a6el3w">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-350" data-mp="2vftevzlwtgpg">
          <div id="capital-metrics-heading" data-id="element-351" data-mp="2ve8h814athnd">
            <SectionHeading eyebrow="Capital Metrics Grid" title="Scale, spend and reach behind the headlines" description="Supporting measures of capital deployed, estate governed and people reached." data-id="element-352" data-mp="306tcl72us2t0" />
          </div>

          <dl className="mt-12 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 sm:grid-cols-2 lg:grid-cols-3" data-id="element-353" data-mp="3e61dq5iktkzu">
            {capitalMetrics.map(metric => <div key={metric.label} className="flex flex-col bg-white p-8" data-id="element-354" data-mp="3j31k6hjc8prh">
                <dd className="font-display text-3xl font-extrabold tracking-tightest text-navy-900" data-id="element-355" data-mp="354utpmgpxs1u">
                  {metric.value}
                </dd>
                <dt className="mt-3 font-display text-sm font-bold uppercase tracking-[0.1em] text-gold-600" data-id="element-356" data-mp="1tqh8kpdcnqpi">
                  {metric.label}
                </dt>
                <dd className="mt-auto pt-4 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-357" data-mp="1yn7nvahbyi9v">
                  {metric.detail}
                </dd>
              </div>)}
          </dl>
        </div>
      </section>
    </PageShell>;
}